// Services
import { addEngagementCallback } from '../../analytics/engagementService';

// Constants
import { PUSH_NOTIFICATIONS_GUIDE_CALLBACK_KEY } from '../../analytics/engagementCallbackKeys';

// Types
import { PushSubscriptionRequest } from './pushNotificationsRequest';

/** Wires the subscribe request to its Amplitude Guide CTA, before or after the SDK has booted. */
export const registerPushNotificationsEngagementCallback = (request: PushSubscriptionRequest): void => {
    addEngagementCallback(PUSH_NOTIFICATIONS_GUIDE_CALLBACK_KEY, request);
};
